import { render } from "./work-order-modal.vue?vue&type=template&id=bc45eac4"
import script from "./work-order-modal.vue?vue&type=script&lang=js"
export * from "./work-order-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__